export default {
  urls: {
    bullhorn: process.env.API_URL_BULLHORN,
  }
}
